import React from 'react';
import PropTypes from 'prop-types';
import RitSelect from '../RitSelect';

const SelectComponent = (options) => {
    const { defaultValue, input: { value }, values } = options;

    let defaulText = options.defaulText;
    if (value) {
        values.forEach((item) => {
            if (item.attrValue === value) {
                defaulText = item.shortName;
            }
        })
    } else if(defaultValue) {
        values.forEach((item) => {
            if (item.attrValue === defaultValue) {
                defaulText = item.shortName;
            }
        })
    }

    const optionsList = values.map(item => { return { name: item.shortName, value: item.attrValue } })
    return (
        <div className='b-select-options'>
            <div className='b-select-options__label'>
                {options.label}
            </div>

            <div className='b-select-options__select'>
                <RitSelect
                    defaultText={defaulText}
                    value={value}
                    onChange={options.input.onChange}
                    optionsList={optionsList}
                    disabledOptions={options.disabled}
                />
            </div>

        </div>
    )
}

SelectComponent.propTypes = {
    defaultValue: PropTypes.string.isRequired,
    values: PropTypes.array.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.any.isRequired,
    input: PropTypes.object.isRequired,
}

export default SelectComponent;